import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import { useTranslation } from 'react-i18next';

import { numFont } from '../../utils/fonts';

// Centralized customer service: one address and one number for every workshop
export const SUPPORT_EMAIL = 'asiakaspalvelu@verstaani.fi';
export const SUPPORT_PHONE = '+358505059448';
export const SUPPORT_PHONE_DISPLAY = '+358 50 505 9448';

// The help site (/ohjeet/, served by Django, login required) exists in Finnish and Swedish
export function guidesBase(language) {
  return language === 'sv' ? '/ohjeet/sv/' : '/ohjeet/';
}

/**
 * Email and phone lines of customer service, shared by the support page and the large chat
 * dialog. The phone is deliberately the quietest line: the guides and the assistant answer
 * faster, and every call is one we cannot scale.
 */
export function SupportContacts() {
  const { t } = useTranslation();
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
        <MailOutlineIcon fontSize="small" sx={{ color: 'text.secondary' }} />
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {t('supportPage.email')}:
        </Typography>
        <Link href={`mailto:${SUPPORT_EMAIL}`} variant="body2" data-testid="support-email">
          {SUPPORT_EMAIL}
        </Link>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
        <PhoneOutlinedIcon fontSize="small" sx={{ color: 'text.secondary' }} />
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {t('supportPage.phone')}:
        </Typography>
        <Link
          href={`tel:${SUPPORT_PHONE}`}
          variant="body2"
          color="text.secondary"
          data-testid="support-phone"
          sx={{ ...numFont }}
        >
          {SUPPORT_PHONE_DISPLAY}
        </Link>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          ({t('supportPage.hours')})
        </Typography>
      </Box>
    </Box>
  );
}
